/* src/app/ai-studio-container/ai-studio-container.component.css */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.ai-studio-container-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.studio-controls {
  padding: 0.5rem 1rem;
  border-bottom: 1px solid var(--surface-d);
  background-color: var(--surface-a);
}
:host ::ng-deep .tabs-full-height {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
}
:host ::ng-deep .tabs-full-height > .p-tabs-nav {
  flex-shrink: 0;
}
:host ::ng-deep .tabs-full-height .p-tabview-panels {
  flex-grow: 1;
  display: flex;
  overflow: hidden;
}
:host ::ng-deep .tabs-full-height .p-tabview-panel {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
}
.p-tab-close-icon {
  cursor: pointer;
  padding: 2px;
  border-radius: 50%;
  transition: background-color 0.2s;
}
.p-tab-close-icon:hover {
  background-color: var(--surface-hover);
}
.session-host-outlet {
  flex-grow: 1;
  overflow: hidden;
  position: relative;
}
.no-sessions-message {
  text-align: center;
  color: var(--text-color-secondary);
}
.full-height-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.router-outlet-container {
  flex-grow: 1;
  position: relative;
  overflow: hidden;
}
.loading-indicator {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
}
/*# sourceMappingURL=ai-studio-container.component-NFY7GQWX.css.map */
